// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
body{
  background-color: #1ABC9C!important;
} */
 .resumehome{
  background-color: #1ABC9C!important;
  margin: 0px !important;
  padding: 0px !important;
  width:100% !important;
  /* margin-top: 120px; */

    overflow-y: hidden;
 }

.createcv{
  text-align: center;
  width: 240px;
  border-radius: 10px;
  padding: 10px !important;
  align-items: start;
}

.use{
 display: none;
  text-align: center;
  width: 100px;
  color: white;
 
}
.use a{
 
  color: white !important;
  text-decoration: none;
}
.use{
  display: none;
}
.hover-area:hover .use{
  display: inline;
}

.btn-lg {
  
  color: #fff; /* White text color */
  border: none; /* Remove border */
 
  border-radius: 5px; /* Add border radius */
  cursor: pointer; /* Change cursor to pointer on hover */
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
  padding: 0.5rem 1rem;
  border-right: 2px solid #111f1c;
   border-bottom: 2px solid #111f1c; 
  border-radius: 0.3rem;
}

/* Hover effect */
.btn-lg:hover {
  background-color: #8a1919; /* Lighter shade of red */
}

.pm {
text-align: left;
/* margin-left: 160px; */
font-family: "Times New Roman, Times, serif";
font-size:larger

}

.bm{
  margin:0
}
@media (min-width: 410px) and (max-width: 768px) {
  .tm{
    margin: 6px;
  }
  .pm{
    margin-left: 6px !important;
  }
  .createcv{
    margin-left: 6px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Resume/Home.css"],"names":[],"mappings":"AAAA;;;GAGG;CACF;EACC,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;;IAErB,kBAAkB;CACrB;;AAED;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;CACC,aAAa;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;;AAEd;AACA;;EAEE,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW,EAAE,qBAAqB;EAClC,YAAY,EAAE,kBAAkB;;EAEhC,kBAAkB,EAAE,sBAAsB;EAC1C,eAAe,EAAE,sCAAsC;EACvD,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,+BAA+B;GAC9B,gCAAgC;EACjC,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;AACA,gBAAgB;AAChB,wBAAwB;AACxB,4CAA4C;AAC5C;;AAEA;;AAEA;EACE;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* \r\nbody{\r\n  background-color: #1ABC9C!important;\r\n} */\r\n .resumehome{\r\n  background-color: #1ABC9C!important;\r\n  margin: 0px !important;\r\n  padding: 0px !important;\r\n  width:100% !important;\r\n  /* margin-top: 120px; */\r\n\r\n    overflow-y: hidden;\r\n }\r\n\r\n.createcv{\r\n  text-align: center;\r\n  width: 240px;\r\n  border-radius: 10px;\r\n  padding: 10px !important;\r\n  align-items: start;\r\n}\r\n\r\n.use{\r\n display: none;\r\n  text-align: center;\r\n  width: 100px;\r\n  color: white;\r\n \r\n}\r\n.use a{\r\n \r\n  color: white !important;\r\n  text-decoration: none;\r\n}\r\n.use{\r\n  display: none;\r\n}\r\n.hover-area:hover .use{\r\n  display: inline;\r\n}\r\n\r\n.btn-lg {\r\n  \r\n  color: #fff; /* White text color */\r\n  border: none; /* Remove border */\r\n \r\n  border-radius: 5px; /* Add border radius */\r\n  cursor: pointer; /* Change cursor to pointer on hover */\r\n  color: #fff;\r\n  background-color: #dc3545;\r\n  border-color: #dc3545;\r\n  padding: 0.5rem 1rem;\r\n  border-right: 2px solid #111f1c;\r\n   border-bottom: 2px solid #111f1c; \r\n  border-radius: 0.3rem;\r\n}\r\n\r\n/* Hover effect */\r\n.btn-lg:hover {\r\n  background-color: #8a1919; /* Lighter shade of red */\r\n}\r\n\r\n.pm {\r\ntext-align: left;\r\n/* margin-left: 160px; */\r\nfont-family: \"Times New Roman, Times, serif\";\r\nfont-size:larger\r\n\r\n}\r\n\r\n.bm{\r\n  margin:0\r\n}\r\n@media (min-width: 410px) and (max-width: 768px) {\r\n  .tm{\r\n    margin: 6px;\r\n  }\r\n  .pm{\r\n    margin-left: 6px !important;\r\n  }\r\n  .createcv{\r\n    margin-left: 6px !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
